module.exports = __webpack_public_path__ + "static/media/RM007_COVER1_FORPRINT_compressed-03.16897e86.jpg";